import React from 'react';
import SkeletonLoader, { SkeletonText } from './SkeletonLoader';
import './ShippingMethodSkeleton.css';

const ShippingMethodSkeleton = () => {
  return (
    <div className="shipping-method-skeleton">
      {/* Shipping Method 1 - Standard (largo) */}
      <div className="shipping-option-skeleton">
        <div className="radio-skeleton">
          <SkeletonLoader width="20px" height="20px" borderRadius="50%" />
        </div>
        <div className="info-skeleton">
          <SkeletonText width="140px" height="14px" marginBottom="4px" />
          <SkeletonText width="105px" height="12px" />
        </div>
        <div className="price-skeleton">
          <SkeletonText width="55px" height="16px" />
        </div>
      </div>

      {/* Shipping Method 2 - Express (medio) */}
      <div className="shipping-option-skeleton">
        <div className="radio-skeleton">
          <SkeletonLoader width="20px" height="20px" borderRadius="50%" />
        </div>
        <div className="info-skeleton">
          <SkeletonText width="95px" height="14px" marginBottom="4px" />
          <SkeletonText width="80px" height="12px" />
        </div>
        <div className="price-skeleton">
          <SkeletonText width="55px" height="16px" />
        </div>
      </div>

      {/* Shipping Method 3 - Overnight (corto) */}
      <div className="shipping-option-skeleton">
        <div className="radio-skeleton">
          <SkeletonLoader width="20px" height="20px" borderRadius="50%" />
        </div>
        <div className="info-skeleton">
          <SkeletonText width="110px" height="14px" marginBottom="4px" />
          <SkeletonText width="70px" height="12px" />
        </div>
        <div className="price-skeleton">
          <SkeletonText width="55px" height="16px" />
        </div>
      </div>
    </div>
  );
};

export default ShippingMethodSkeleton;
